import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"plus\"><path d=\"M14 8H8v6H6V8H0V6h6V0h2v6h6v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol